module.exports = __webpack_public_path__ + "img/bgc.3cad28ec.png";